module.exports = __webpack_public_path__ + "img/button_about.3541f585.png";